import { create } from "zustand";
import { devtools } from "zustand/middleware";

const initialState = {
  applicationData:null,
  editSlug:null,
  mccOptions: [],
  step: 0,
  isAnonymousVerified: true,
  isOtpSent: false,
  isAuthenticated: false,
  otpCode: "",
  activeSigner: null,
  activeOtpMethod: "sms",
  countryList: [],
  otpVerificationTime: null,
  minimumData: null,
  isSignInPersonModalOpen: false,
  signerType: undefined,
  uploadedFiles: [],
};

const useSalesFormStore = create(
  devtools((set) => ({
    ...initialState,
    setApplicationData: (t) => set({ applicationData: t }),
    setEditSlug: (t) => set({ editSlug: t }),
    setMccOptions: (t) => set({ mccOptions: t }),
    setStep: (t) => set({ step: t }),
    reset: () => set(initialState),
    setIsAnonymousVerified: (t) => set({ isAnonymousVerified: t }),
    setIsAuthenticated: (t) => set({ isAuthenticated: t }),
    setIsOtpSent: (t) => set({ isOtpSent: t }),
    setOtpCode: (t) => set({ otpCode: t }),
    setActiveSigner: (t) => set({ activeSigner: t }),
    setActiveOtpMethod: (t) => set({ activeOtpMethod: t }),
    setCountryList: (t) => set({ countryList: t }),
    setOtpVerificationTime: (t) => set({ otpVerificationTime: t }),
    setMinimumData: (t) => set({ minimumData: t }),
    setIsSignInPersonModalOpen: (t) => set({ isSignInPersonModalOpen: t }),
    setSignerType: (t) => set({ signerType: t }),
    setUploadedFiles: (t) => set({ uploadedFiles: t }),
  })),
);

export default useSalesFormStore;
